import React from 'react';
import { Grid } from '@material-ui/core';
import withStyles from '@material-ui/styles/withStyles';

import { EMPTY_LIST, PROJECT_STATUS as ProjectStatus } from 'app/app.constants';
import ReadOnlyField from 'app/components/ReadOnlyField';
import { getTotalElapsedTime } from 'utils/activity.util';
import { formatDuration, formatDurationDiff } from 'utils/format.util';
import { TimerType } from 'features/projects/activities/activities.constants';
import { timerTypeToDisplayName } from 'features/projects/activities/activities.mappers';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  downloadEndOfJobReport,
  downloadEndOfJobReportAsExcel,
} from 'features/projects/report/report.actions';

import { DownloadReportButton } from 'features/projects/report/components/ReportContainerHeader/components/DownloadReportButton';
import { getSummarizedDataStateFromState } from 'app/app.selectors';
import { REPORT_ACTIONS } from 'features/projects/report/report.constants';
import { LoadingOverlay } from 'altus-ui-components';

const ReportContainerHeader = ({
  totalNpt,
  timersByType,
  totalElapsedDuration,
  totalPlannedDuration,
  dispatchDownloadEndOfJobReport,
  dispatchDownloadEndOfJobReportAsExcel,
  projectExternalId,
  projectStatus,
  dataState,
  activities = EMPTY_LIST,
}) => {
  const totalTimeWait = getTotalElapsedTime(
    activities.filter((activity) => activity.get('isWait')),
  );
  return (
    <>
      <LoadingOverlay
        timeout={0}
        dataState={dataState}
        text={'Generating report...'}
      />
      <Grid container justifyContent="space-between">
        <Grid item>
          <ReadOnlyField
            label="Time Spent"
            value={formatDuration(totalElapsedDuration)}
          />
        </Grid>
        <Grid item>
          <ReadOnlyField
            label="Time Planned"
            value={formatDuration(totalPlannedDuration)}
          />
        </Grid>
        <Grid item>
          <ReadOnlyField
            label="Difference"
            value={formatDurationDiff(
              totalElapsedDuration,
              totalPlannedDuration,
            )}
          />
        </Grid>
        <Grid item>
          <ReadOnlyField
            label="Waiting"
            value={formatDuration(totalTimeWait)}
          />
        </Grid>
        <Grid item>
          <ReadOnlyField
            label="Non-productive time"
            value={formatDuration(totalNpt)}
          />
        </Grid>
        {Object.values(TimerType).map((timerType) => {
          const timers = timersByType[timerType];

          return (
            <Grid item key={timerType}>
              <ReadOnlyField
                label={timerTypeToDisplayName(timerType)}
                value={formatDuration(getTotalElapsedTime(timers))}
              />
            </Grid>
          );
        })}
        {projectStatus === ProjectStatus.REPORT && (
          <DownloadReportButton
            downloadEndOfJobReport={() =>
              dispatchDownloadEndOfJobReport({ projectExternalId })
            }
            downloadEndOfJobReportAsExcel={() =>
              dispatchDownloadEndOfJobReportAsExcel({ projectExternalId })
            }
          />
        )}
      </Grid>
    </>
  );
};

const styles = (theme) => ({
  emptyIcon: {
    fontSize: 200,
    color: theme.palette.action.disabled,
  },
});

const mapStateToProps = (state) => ({
  dataState: getSummarizedDataStateFromState(
    state,
    REPORT_ACTIONS.PROJECT_REPORT_END_OF_JOB,
    REPORT_ACTIONS.PROJECT_REPORT_END_OF_JOB_AS_EXCEL,
  ),
});

const mapDispatchToProps = {
  dispatchDownloadEndOfJobReport: downloadEndOfJobReport,
  dispatchDownloadEndOfJobReportAsExcel: downloadEndOfJobReportAsExcel,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles),
)(ReportContainerHeader);
